global.initScrollable = function (target) {
  $(target).find('.scrollable').each(function () {
    const $scrollable = $(this);

    // 1. Vérifie si .scrollable__content existe déjà
    let $content = $scrollable.find('.scrollable__content').first();

    // 2. Sinon on wrap automatiquement le contenu existant
    if ($content.length === 0) {
      $scrollable
        .children()
        .wrapAll('<div class="scrollable__content"></div>');

      $content = $scrollable.find('.scrollable__content').first();
    }

    const viewport = $scrollable[0];
    const content = $content[0];

    // 3. Init ScrollBooster
    const sb = new ScrollBooster({
      viewport,
      content,
      scrollMode: 'native',
      textSelection: false,
    });

    // 4. Store instance
    $scrollable.data('scrollbooster', sb);

  });
};